import { reactive, toRefs, provide, inject } from "@vue/composition-api";

export const state = reactive({
    selectedFolder: null,
    dialog: false,
    loading: false,
    requestOngoing: false,
    localStorageCacheKey: 'documents-folder-select'
});

export const actions = {
    selectFolder(folder) {
        state.selectedFolder = folder
    },
    openDialog() {
        state.dialog = true
    },
    closeDialog() {
        state.dialog = false
    },
    getCachedFolders() {
        const cachedFoldersData = JSON.parse(localStorage.getItem(state.localStorageCacheKey))
        if (Math.max(Number(cachedFoldersData?.validUntil ? cachedFoldersData.validUntil : 0), 1) > new Date().valueOf() && cachedFoldersData.list) {
            // cached list exists and is still valid
            return cachedFoldersData
        } else if(cachedFoldersData?.validUntil) {
            // cached data exists, but is no longer valid
            localStorage.removeItem(state.localStorageCacheKey)
        }
        return {list: [], service: null}
    },
    clearCachedFolders() {
        localStorage.removeItem(state.localStorageCacheKey)
    },
    setCachedFolders(folders, service) {
        const now = new Date()
        const h = 100  // how many hours is the cache valid for
        now.setTime(now.getTime() + (h*60*60*1000))
        const cachedFoldersData = JSON.stringify({validUntil: now.valueOf(), list: folders, service: service})
        localStorage.setItem(state.localStorageCacheKey, cachedFoldersData)
    },
    getDriveLink(service, folderId, fallback) {
        if(service === 'onedrive') {
            return `https://onedrive.live.com/?id=${folderId}`
        }
        else if (service === 'google_drive'){
            if(!folderId) return 'https://drive.google.com/drive/u/0/home'
            return `https://drive.google.com/drive/u/0/folders/${folderId}`
        } else if(service === 'sharepoint') {
            return fallback
        }
    }
};

export const getters = {

};

export const key = Symbol("DocumentsModule");

export const provideDocuments = () => {
    provide(key, {
        ...toRefs(state),
        ...getters,
        ...actions
    });
};

export default () => inject(key);
